{
  "privacyPolicy": "Política de Privacidad",
  "legacyMessage": "Usamos cookies para comprender como usa nuestro sitio y mejorar su experiencia. Al continuar usando nuestro sitio, acepta nuestro uso de cookies y nuestra",
  "message": "Usamos almacenamiento necesario para recordar sus elecciones. El seguimiento cubre cookies y métodos que no usan cookies, e incluye analíticas y almacenamiento opcional. Consulte nuestra",
  "agree": "ESTOY DE ACUERDO",
  "acceptTracking": "Aceptar seguimiento",
  "rejectTracking": "Rechazar seguimiento",
  "readMore": "Leer más",
  "preferences": {
    "title": "Preferencias de cookies",
    "description": "Su elección se aplica al seguimiento, incluidas las cookies y los métodos que no usan cookies. Gobierna a la vez las analíticas y el almacenamiento opcional. El almacenamiento necesario permanece activo.",
    "tracking": {
      "title": "Seguimiento",
      "description": "Permita las analíticas y el almacenamiento opcional. Esto cubre cookies y otros métodos de seguimiento."
    },
    "cancel": "Cancelar",
    "save": "Guardar"
  },
  "a11y": {
    "readMore": "Leer más acerca de la Política de Privacidad",
    "readMorePreferences": "Leer más acerca de las preferencias de cookies",
    "accept": "Aceptar seguimiento",
    "reject": "Rechazar seguimiento",
    "agree": "Acepto el uso de cookies",
    "close": "Cerrar banner de aceptación de cookies",
    "closePreferences": "Cerrar las preferencias de cookies"
  }
}
